(function() {
  if (window.POPOSOAPLCV6 && window.POPOSOAPLCV6.ready) {
    return;
  }

  window.POPOSOAPLCV6 = window.POPOSOAPLCV6 || {};
  window.POPOSOAPLCV6.ready = true;

  function initSection(section) {
    if (!section || section.dataset.plc6Ready === 'true') {
      return;
    }

    section.dataset.plc6Ready = 'true';
    section.classList.add('is-ready');

    var revealItems = section.querySelectorAll('.plc6-reveal');

    if (!('IntersectionObserver' in window) || !revealItems.length) {
      revealItems.forEach(function(item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    });

    revealItems.forEach(function(item) {
      observer.observe(item);
    });
  }

  function initAll() {
    document.querySelectorAll('.plc6-section').forEach(initSection);
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-plc6-scroll]');

    if (!link) {
      return;
    }

    var href = link.getAttribute('href');

    if (!href || href.charAt(0) !== '#') {
      return;
    }

    var target = document.querySelector(href);

    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
